export type ApiError = { error: string; [k: string]: unknown };

let refreshInFlight: Promise<boolean> | null = null;

async function tryRefresh(): Promise<boolean> {
  if (!refreshInFlight) {
    refreshInFlight = fetch('/api/auth/refresh', { method: 'POST', credentials: 'include' })
      .then((r) => r.ok)
      .catch(() => false)
      .finally(() => { refreshInFlight = null; });
  }
  return refreshInFlight;
}

async function rawFetch(path: string, init?: RequestInit): Promise<Response> {
  const headers: Record<string, string> = { ...(init?.headers as Record<string, string> ?? {}) };
  if (init?.body !== undefined && init?.body !== null && headers['Content-Type'] === undefined) {
    headers['Content-Type'] = 'application/json';
  }
  return fetch(path, {
    credentials: 'include',
    ...init,
    headers,
  });
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  let r = await rawFetch(path, init);

  // Автоматический refresh access-cookie при 401, кроме самих auth-эндпоинтов
  if (r.status === 401 && !path.startsWith('/api/auth/')) {
    const ok = await tryRefresh();
    if (ok) r = await rawFetch(path, init);
  }

  if (!r.ok) {
    let body: ApiError = { error: 'http_' + r.status };
    try {
      body = (await r.json()) as ApiError;
    } catch {
      // не JSON — оставляем default
    }
    throw Object.assign(new Error(body.error ?? `http_${r.status}`), {
      status: r.status,
      body,
    });
  }
  return r.json() as Promise<T>;
}
